import { useQuery } from "@apollo/client";
import { GET_SALON_ACCESS_STATE } from "@/graphql/salon";

export function useSalonAccessState(salonId: string | undefined) {
  const { data, loading } = useQuery(GET_SALON_ACCESS_STATE, {
    variables: { salonId: salonId ?? "" },
    skip: !salonId,
    fetchPolicy: "cache-and-network",
  });

  return {
    suspended: data?.salonAccessState?.suspended ?? false,
    reason: data?.salonAccessState?.reason ?? null,
    source: data?.salonAccessState?.source ?? null,
    contactWhatsApp: data?.salonAccessState?.contactWhatsApp ?? null,
    loading,
  };
}
